import { EntityTypeDTO } from '../../DocumentVault.meta';

export const ENTITY_ICONS = {
  [EntityTypeDTO.File]: 'far fa-file-alt',
  [EntityTypeDTO.Folder]: 'far fa-folder',
  [EntityTypeDTO.Video]: 'fas fa-video',
};
